<template>
    <div>
        <b-modal :active.sync="cancelPaymentModalOpen" class="cancelmodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Betaling annuleren</p></header>
                <section class="modal-card-body" style="overflow:hidden;border-radius:0;">
                    <p>Geef een reden op waarom de ingeplande betaling geannuleerd dient te worden.</p>

                    <b-field label="Reden">
                        <b-input maxlength="200" type="textarea" v-model="cancelText"></b-input>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" @click="cancelPaymentModal" :disabled="cancelling">Annuleren</b-button>
                    <b-button type="is-success" @click="cancelInvoice" :loading="cancelling" :disabled="!cancelText.length || cancelling">Bevestigen</b-button>
                </footer>
            </div>
        </b-modal>

        <b-table
            :data="records"
            :striped="true"
            :mobile-cards="true"

            :paginated="false"
            :sort-icon="'chevron-up'"
            :row-class="(row) => { return { 'is-cancelled': row.status === 'cancelled' } }"
        >
            <template>
                <b-table-column v-slot="props" field="type" label="Type">
                    {{ getType(props.row.type, props.row.credit_of)|capitalize }}
                    <!-- {{ props.row.type == 'manual' ? 'Handmatig' : props.row.type|capitalize }} -->
                </b-table-column>

                <b-table-column v-slot="props" field="status" label="Status">
                    {{ getStatus(props.row.status, props.row.hold) }}
                </b-table-column>

                <b-table-column v-slot="props" field="total" label="Totaal" numeric>
                    <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                    <span v-else>{{ parseFloat(props.row.total) > 0 ? '&euro;&nbsp;'+props.row.total : ((props.row.type == 'manual' || props.row.type == 'manual_cash') && (props.row.status == 'open' || props.row.status == 'open_due' || props.row.status == 'open_paid')) ? '&euro;&nbsp;0.00' : '' }}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="paid" label="Betaald" numeric>
                    <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                    <span v-else>{{ parseFloat(props.row.paid) > 0 ? '&euro;&nbsp;'+parseFloat(props.row.paid).toFixed(2) : '-' }}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="payment_date" label="(Incasso) datum">
                    <!-- <span v-if="props.row.type == 'manual' && props.row.status == 'open'">{{ props.row.payment_date|humanDate }}</span> -->
                    <span>{{ props.row.payment_date|humanDate }}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="created_at" label="Aangemaakt op">
                    {{ props.row.created_at|humanDate }}
                </b-table-column>

                <b-table-column v-slot="props" field="paynl_status" label="Statuscode">
                    <span v-if="props.row.type == 'manual' || props.row.type == 'manual_cash'">N.v.t.</span>
                    <span v-else>
                        <span v-if="hideSensitiveData">*****</span>
                        <span v-else>
                            {{ props.row.paynl_status || '-' }}
                            <b-button tag="a" href="https://docs.pay.nl/developers?language=nl#direct-debit-statuses" target="_blank" size="is-small" icon-right="external-link-alt" v-if="!_.isNull(props.row.paynl_status) && !_.includes([94, 100, 91, 526], props.row.paynl_status)"></b-button>
                        </span>
                    </span>
                </b-table-column>

                <b-table-column v-slot="props" label="Annuleren">
                    <b-button type="is-gray" size="is-small" v-if="isCancelable(props.row)" @click="cancelPaymentId = props.row.id; cancelPaymentModalOpen = true">Annuleer</b-button>
                    <span v-else-if="props.row.status == 'cancelled'"><small><i>{{ props.row.updated_at|humanDate }} geannuleerd</i></small></span>
                    <span v-else>-</span>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0">Geen betalingen gevonden.</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import toastMixin from '@/mixins/toastMixins.js'

export default {
    name: 'InvoicePaymentsTable',
    mixins: [filtersMixin, toastMixin],

    props: {
        records: {
            type: Array,
            required: false
        }
    },

    data() {
        return {
            cancelPaymentModalOpen: false,
            cancelPaymentId: null,
            cancelling: false,
            cancelText: ''
        }
    },

    computed: {
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    methods: {
        getStatus(status, hold = false){
            if (hold) return 'Wacht op bevestiging'

            switch(status){
                case 'planned':
                    return 'Ingepland'
                break;
                case 'paid':
                    return 'Betaald'
                break;
                case 'open':
                case 'open_paid':
                case 'open_due':
                    return 'Open'
                case 'failed':
                    return 'Mislukt'
                case 'cancelled':
                    return 'Geannuleerd'
                case 'incasso_planned':
                    return 'Incasso aangemeld'
                case 'incasso_planned_bank':
                    return 'Incasso aangemeld bij bank'
                case 'storno':
                    return 'Gestorneerd'
                case 'pending_mandate':
                    return 'Wachtende incasso'
                default:
                    return status
            }
        },

        getType(type, credit_of){
            if (!_.isNull(credit_of)) {
                return 'Creditfactuur'
            }

            if (type == 'manual') return 'Overschrijving'
            if (type == 'manual_cash') return 'Cash'
            return type
        },

        isCancelable(payment) {
            return payment.type == 'incasso' && payment.in_out == 'in' && (payment.status == 'planned')
        },

        cancelPaymentModal(){
            this.cancelPaymentModalOpen = false
            this.cancelling = false
            this.cancelText = ''
        },

        cancelInvoice() {
            if(_.isNull(this.cancelPaymentId)) return false;
            this.cancelling = true

            axios.post(`/api/invoice_payment/${this.cancelPaymentId}/cancel`, {reason: this.cancelText}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage('Ingeplande betaling is succesvol geannuleerd!')
                this.$emit('loadInvoice')
            }).catch((error) => {
                console.error('[❌] Error while validating the payment:', error)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
            }).then(() => {
                this.cancelPaymentModal()
            })
        }
    }
}
</script>
